import { Modal } from '@olxbr/ds-web'
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import useWindowSize from '../../../util/useWindowSize'
import { breakpoints } from '../../../util/medias'

const StyledFlex = styled.div`
  display: flex;
  @media screen and (max-width: ${breakpoints['mobile']}px) {
    text-align: center;
    align-items: center;
    justify-content: center;
  }
  flex-direction: column;
`

const Wrapper = styled.div`
  div[data-ds-component='DS-Modal'] {
    div[role='dialog'] {
      @media screen and (max-width: ${breakpoints['mobile']}px) {
        padding: var(--spacing-3);
      }
    }
  }
`

const ButtonsWrapper = styled.div`
  @media screen and (min-width: ${breakpoints['mobile'] + 1}px) {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
    margin-top: var(--spacing-1);
    margin-bottom: var(--spacing-1);
  }
`

export const ResponsiveModal = ({ children, renderButtons, closeModal, isOpen }) => {
  const { isMobile } = useWindowSize()

  return (
    <Wrapper>
      <Modal
        preventCloseOnOutsideClick
        open={isOpen}
        size={isMobile ? 'small' : 'medium'}
        maxWidth={!isMobile ? '600px' : undefined}
        closeCallback={closeModal}
        desktopModalVariant={!isMobile}
      >
        <StyledFlex>
          {children}
          <ButtonsWrapper>{renderButtons}</ButtonsWrapper>
        </StyledFlex>
      </Modal>
    </Wrapper>
  )
}

ResponsiveModal.propTypes = {
  renderButtons: PropTypes.element,
}
